export enum Brand {
  SE_BRAND =  'se'
}

export type CreateURLOptions = {
  host?: string;
  contextRoot?: string;
  endpoint: string;
  queryParams: Record<string,string>
};

export type TLocaleObj = {
  countryCode: string,
  languageCode: string
}

export type CreatePesIconOptions = {
  iconName: string;
  size?: string;
  className?: string;
};
